/* eslint-disable react/no-unused-class-component-methods */
/* eslint-disable object-property-newline */
import React from 'react';
import { Auth } from '@leverege/api-redux';
import { createConnect } from '@leverege/ui-plugin';
import { UserSettings } from '@leverege/ui-redux';
import { Attributes, DataSourceFactory, DataSources } from '@leverege/ui-attributes';
import { ValuesCache } from '@leverege/value-cache';
import I18N from '@leverege/i18n';
import Util from "../group/Util.js";
import Key from "../utils/Key.js";
import ViewerModel from "../../dataViewers/layout/ViewerModel.js";
import Converter from "../../dataViewers/converter/ViewerModelConverter.js";
import SingleItemPaginator from "./SingleItemPaginator.js";
import DataViewers from "../../dataViewers/DataViewers.js";
import OverridesReducer from "../../dataViewers/overrides/OverridesReducer.js";
import ReduxOverrides from "../../dataViewers/overrides/ReduxOverrides.js";
import LayoutVersions from "../../dataViewers/layout/LayoutVersions.js";
import LayoutMethods from "../../dataViewers/layout/LayoutMethods.js";
const {
  t
} = I18N.ns('molten.screens.itemInfo.AbstractItemInfoScreen');
class AbstractItemInfoScreen extends React.Component {
  static CLIENT = 'ItemInfoScreen';
  constructor(props) {
    super(props);
    this.cache = new ValuesCache();
    this.paginator = new SingleItemPaginator();
    this.overrides = new ReduxOverrides(props.settingsPath, {
      state: props.overrides
    });
    this.mobile = false;
    this.matchContext = {
      client: AbstractItemInfoScreen.CLIENT,
      clientType: props.clientType || AbstractItemInfoScreen.CLIENT,
      path: props.relationship?.path,
      objectType: props.relationship?.objectType,
      relationship: props.relationship,
      mobile: false
    };
    this.state = {
      modifiedLayout: null
    };
    this.dataViewers = new DataViewers({
      ...this.matchContext,
      type: 'ItemInfoDataViewer'
    });
    LayoutMethods.install(this, {});
  }
  getContext() {
    const {
      item,
      relationship,
      reloadData,
      layout
    } = this.props;
    const {
      modifiedLayout
    } = this.state;
    const ctxItem = [{
      ...relationship.objRef,
      data: item
    }];
    return {
      ...this.matchContext,
      target: DataSources.withData(ctxItem),
      clientProps: this.props,
      mobile: this.mobile,
      reloadData,
      onViewerChange: this.onViewerChange,
      getDataViewerProps: this.getDataViewerProps,
      layout: {
        ...layout,
        modifiedLayout,
        onLayoutChange: this.onLayoutChange,
        onLayoutRevert: this.onLayoutRevert,
        onLayoutSave: this.onLayoutSave,
        onLayoutDelete: this.onLayoutDelete,
        onLayoutRename: this.onLayoutRename
      }
    };
  }
  getTitle() {
    const {
      relationship: {
        objectType
      },
      nameAttr = 'name',
      title: pTitle,
      item
    } = this.props;
    return pTitle || Attributes.get(nameAttr, objectType, item) || t('title');
  }
  getIcon() {
    const {
      relationship: {
        attribute,
        blueprint
      },
      icon: pIcon
    } = this.props;
    return pIcon || (attribute ? attribute.getIcon('screenIcon') || blueprint?.getIcon('screenIcon') : blueprint?.getIcon('screenIcon'));
  }

  // onUpdateSettings = ( evt ) => {
  //   try {
  //     const { settings, name } = this.props
  //     const nSettings = ViewerModel[evt.data]( settings, evt.value )
  //     UserSettings.set( getSettingsPath( this.props, name, 'LayoutModel' ), nSettings )
  //     this.onViewerChange( { value : nSettings } )
  //   } catch ( ex ) {
  //     // eslint-disable-next-line no-console
  //     console.error( ex )
  //   }
  // }

  onUpdateSettings = evt => {
    try {
      const {
        modifiedLayout
      } = this.state;
      const {
        settings
      } = this.props;
      const nSettings = ViewerModel[evt.data](modifiedLayout || settings, evt.value);
      this.setState({
        modifiedLayout: nSettings
      });
    } catch (ex) {
      // eslint-disable-next-line no-console
      console.error(ex);
    }
  };
  onViewerChange = event => {
    const v = event.value;
    this.setState({
      modifiedLayout: v
    });
  };
  onErrorReset = evt => {
    const {
      data: {
        dataViewer,
        props
      }
    } = evt;
    if (typeof dataViewer?.reset === 'function') {
      return dataViewer.reset(props);
    }
    return null;
  };
  getHiddenDataViewers() {
    return this.dataViewers.getFor('hidden');
  }
  getDataViewerProps = () => {
    const {
      dispatch,
      item,
      delegate,
      actions,
      match,
      location,
      history,
      targetKey,
      profile,
      parentItem,
      overrides,
      settings,
      settingsPath,
      reloadData
    } = this.props;
    const {
      modifiedLayout
    } = this.state;
    const currLayout = modifiedLayout || settings || {};
    this.overrides = this.overrides.update(overrides, settingsPath);
    return {
      ...this.matchContext,
      selectionKey: 'selected',
      rolloverKey: 'rollover',
      targetKey,
      parentItem,
      dispatch,
      match,
      location,
      history,
      profile,
      item,
      delegate,
      actions,
      paginator: this.paginator,
      dataViewers: this.dataViewers,
      onSettingsChange: this.onUpdateSettings,
      settingsPath,
      isMobile: this.mobile,
      overrides: this.overrides,
      reloadData,
      layout: currLayout
    };
  };
  createDataItems = () => {
    const {
      relationship,
      status,
      loading
    } = this.props;
    const type = relationship.blueprint.type;
    const dataSource = DataSourceFactory.get(type) || {
      getData: () => null
    };
    const obj = {
      ...relationship.objRef
    };
    obj.data = dataSource.getData(obj);
    return {
      page: 0,
      perPage: 1,
      status,
      loading,
      items: [obj]
    };
  };
  render() {
    return null;
  }
}
const connect = createConnect(AbstractItemInfoScreen.CLIENT, (s, props) => ({
  client: AbstractItemInfoScreen.CLIENT,
  objectType: props?.relationship?.objectType,
  path: props?.relationship?.path
}));
const US_OPTS = {
  returnPromise: false
};
function connectChild(component, ep, LayoutModel) {
  const extraProps = ep || {};
  return connect((state, props) => {
    const merged = {
      ...props,
      ...extraProps
    };
    const {
      // name = 'itemInfoScreen',
      // mobileName = 'itemInfoScreenMobile',
      clientSubType,
      relationship,
      match,
      delegate
    } = merged;
    const {
      path,
      objectType
    } = relationship;
    let clientType = merged.clientType || 'ItemInfoScreen';
    if (props.clientType && props.overrideClientType) {
      clientType = props.clientType;
    }
    if (clientSubType) {
      clientType = `${clientType}.${clientSubType}`;
    }
    const client = AbstractItemInfoScreen.CLIENT;
    const settingsPath = Key.forSettings(clientType, path);
    // const mobileSettingsPath = Key.forSettings( mobileName, path )
    const targetKey = Key.usingPersona(match, clientType, path);
    const item = delegate.getItem(state);
    const layout = LayoutVersions.use({
      state,
      path,
      objectType,
      props: merged,
      clientType,
      client
    });
    let settings = layout?.layout;
    settings = settings || UserSettings.get(state, Util.getSettingsPath(merged, clientType, 'LayoutModel'), US_OPTS);
    if (settings == null) {
      // Updates old ViewerModel to LayoutModel
      const old = UserSettings.get(state, Util.getSettingsPath(merged, clientType), US_OPTS);
      settings = Converter.convert(old, {
        settingsRoot: settingsPath
      });
      settings = settings || (LayoutModel || ViewerModel).create();
    }
    return {
      profile: Auth.getProfile(state.auth),
      item,
      status: delegate.getStatus(state),
      loading: delegate.isLoading(state),
      settingsPath,
      // mobileSettingsPath,
      targetKey,
      settings,
      // name,
      overrides: OverridesReducer.getAll(state),
      layout,
      clientType,
      ...extraProps
    };
  })(component);
}
export default AbstractItemInfoScreen;
export { connectChild };